var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmedBoldicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Big / Confirmation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.819984,4.68150917 L11.819984,4.68150917 C11.6254712,4.70765071 11.4530295,4.81978391 11.350349,4.98689742 L7.4750109,10.9353622 L5.7502455,9.70286202 L5.7502455,9.70286202 C5.56191354,9.54669773 5.30198135,9.50888719 5.07689957,9.60491504 C4.85181779,9.70094289 4.69939484,9.91467871 4.68205285,10.1585908 C4.66471087,10.4025028 4.78536289,10.6356197 4.99459801,10.7624724 L7.28080949,12.3920905 C7.42694236,12.4953145 7.60904627,12.5341581 7.78462992,12.4995576 C7.96021357,12.4649572 8.11391784,12.3599394 8.20987808,12.2090086 L12.4558613,5.68978112 L12.4558613,5.68978112 C12.5989796,5.47619026 12.6031242,5.19851663 12.4664445,4.9807568 C12.3297648,4.76299697 12.0777766,4.64580328 11.8230066,4.68150917 L11.819984,4.68150917 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FLOW---MOBILE/DESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Denuncia-Sinistro---MeteoAvverso---Uploaded",
    transform: "translate(-219.000000, -509.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(204.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Big-/-Confirmation",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_13601-path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#059881",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#059881",
    strokeWidth: 1.6,
    cx: 8.57142857,
    cy: 8.57142857,
    r: 8.57142857
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedBoldicon);
export default __webpack_public_path__ + "static/media/confirmed-bold.icon.c7935432c65687c04560acbabf481f5a.svg";
export { ForwardRef as ReactComponent };